export const ICD10_AI_HELPER_URL =
  "https://us-central1-loyalitysystem-d564d.cloudfunctions.net/icd10AiHelper";